import { Component, OnInit } from '@angular/core';
import { RegistrationService } from 'src/app/administration/registrations/registration.service';
import { Registration } from 'src/app/administration/registrations/registration';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-edit-registration-modal',
    templateUrl: './edit-registration-modal.component.html',
    styleUrls: ['./edit-registration-modal.component.scss'],
    standalone: false
})
export class EditRegistrationModalComponent implements OnInit {
  registration: Registration = new Registration();
  isSaving: boolean;
  submitText: string;

  constructor(public diaglogRef: MatDialogRef<EditRegistrationModalComponent>,
    private registrationService: RegistrationService) { }

  ngOnInit() {
  }

  submit() {
    this.isSaving = true;
    this.registrationService.update(this.registration.id, this.registration).subscribe(() => {
      this.diaglogRef.close(this.submitText);
      this.isSaving = false;
    }, err =>{
      this.isSaving = false;
    });
  }

  close() {
    this.diaglogRef.close();
  }
}
